import React from 'react';

import { LinkIconElement } from '@atlaskit/smart-card';
import { EmojiRenderer, useSmartCardEmoji } from '@atlassian/company-hub-common';

import type { LinkIconProps } from './types';

export const LinkIcon = ({ link }: LinkIconProps): React.JSX.Element => {
	const { emojiId } = useSmartCardEmoji(link);

	return (
		<LinkIconElement
			iconTileSize={24}
			render={
				emojiId ? () => <EmojiRenderer emojiId={emojiId} height={24} width={24} /> : undefined
			}
		/>
	);
};
